<template>
  <g>
    <path
      d="M14 10.0002V3.26018C13.35 3.09018 12.68 3.00018 12 3.00018C7.8 3.00018 4 6.22018 4 11.2002C4 14.3802 6.45 18.1202 11.34 22.4302C11.72 22.7602 12.29 22.7602 12.67 22.4302C17.55 18.1202 20 14.3802 20 11.2002C20 10.7902 19.96 10.3902 19.91 10.0002H14ZM12 13.0002C10.9 13.0002 10 12.1002 10 11.0002C10 9.90018 10.9 9.00018 12 9.00018C13.1 9.00018 14 9.90018 14 11.0002C14 12.1002 13.1 13.0002 12 13.0002Z"
    />
    <path
      d="M22.54 2.88018L21.12 1.46018L19 3.59018L16.88 1.46018L15.46 2.88018L17.59 5.00018L15.46 7.12018L16.88 8.54018L19 6.41018L21.12 8.54018L22.54 7.12018L20.41 5.00018L22.54 2.88018Z"
    />
  </g>
</template>
